import Icon from '../Icon.vue'

Icon.register({
  'list': {
    width: 16,
    height: 15,
    paths: [
      {
        d: 'M0 2a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM5 2A1.5 1.5 0 016.5.5h8a1.5 1.5 0 010 3h-8A1.5 1.5 0 015 2zM0 8a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM5 8a1.5 1.5 0 011.5-1.5h8a1.5 1.5 0 010 3h-8A1.5 1.5 0 015 8zM0 14a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM5 14a1.5 1.5 0 011.5-1.5h8a1.5 1.5 0 010 3h-8A1.5 1.5 0 015 14z'
      }
    ]
  }
})
